// extracted by mini-css-extract-plugin
module.exports = {"text":"notfound_text__2wcrd","tag":"notfound_tag__85EHH"};